module.exports = __webpack_public_path__ + "img/loader.cff1a4ee.gif";